var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M26.6663 28C26.6663 26.1392 26.6663 25.2089 26.4367 24.4518C25.9196 22.7473 24.5857 21.4134 22.8812 20.8963C22.1241 20.6667 21.1938 20.6667 19.333 20.6667H12.6663C10.8056 20.6667 9.87521 20.6667 9.11815 20.8963C7.41361 21.4134 6.07973 22.7473 5.56266 24.4518C5.33301 25.2089 5.33301 26.1392 5.33301 28M21.9997 10C21.9997 13.3137 19.3134 16 15.9997 16C12.686 16 9.99968 13.3137 9.99968 10C9.99968 6.68629 12.686 4 15.9997 4C19.3134 4 21.9997 6.68629 21.9997 10Z",
    stroke: "#475467",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.efde52a2bd3eeee34c6b5175ae0f4567.svg";
export { ForwardRef as ReactComponent };